import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ToastContent, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getOTP, validateOTP } from 'services/coversationService';
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';
import brandLogo from '../../assets/images/logo.svg'
import { useDispatch } from 'react-redux';
import { handleLoader } from 'redux/counterSlice';

const ForgotPassword = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const [username, setUsername] = useState("");
    const [otp, setOtp] = useState("");
    const [showOTP, setShowOTP] = useState(false);
    const dispatch = useDispatch();
    const [errors, setErrors] = useState<any>({});
    const navigate = useNavigate();
    const Ref: any = useRef(null);
    let temp = searchParams.get("verify_otp")

    // The state for our timer
    const [timer, setTimer] = useState('00:00:00');

    const getTimeRemaining = (e: any) => {
        const total: any = Date.parse(e) - Date.parse(new Date() as any);
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        };
    }

    const startTimer = (e: any) => {
        let { total, hours, minutes, seconds }
            = getTimeRemaining(e);
        if (total >= 0) {

            // update the timer
            // check if less than 10 then we need to 
            // add '0' at the beginning of the variable
            setTimer(
                (hours > 9 ? hours : '0' + hours) + ':' +
                (minutes > 9 ? minutes : '0' + minutes) + ':'
                + (seconds > 9 ? seconds : '0' + seconds)
            )
        } else {
            localStorage.removeItem("timer");
        }
    }

    const clearTimer = (e: any) => {

        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next    
        setTimer('00:05:00');

        // If you try to remove this line the 
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();
        // This is where you need to adjust if 
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + 300);
        return deadline;
    }

     // Function to reset the timer
     const resetTimer = () => {
        // Clear the interval and reset the timer to 5 minutes
        if (Ref.current) clearInterval(Ref.current);
        setTimer('00:05:00');
        clearTimer(getDeadTime());
    };

    const timerSec: any = localStorage.getItem("timer");
    useEffect(() => {
        if (temp && timerSec) {
            clearTimer(getDeadTime());
        }
    }, [temp, timerSec])

    const handleValidation = () => {
        const errors: any = {};
        if (otp === "") {
            errors.otp = 'Please enter the OTP';
        }

        return errors;
    }
    const handleValidation2 = () => {
        const isValidFormat = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(username);

        const errors: any = {};

        if (username === "") {
            errors.username = 'Email is required';
        } else if (username !== "" && !isValidFormat) {
            errors.username = 'Please enter a valid email address';
        }
        return errors;
    }

    const handlePassword = async (e: any) => {
        e.preventDefault();
        const u_name: any = temp ? localStorage.getItem("email") : username;
        const validationErrors = handleValidation2();
        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await getOTP(u_name)
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                localStorage.setItem("email", u_name);
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                resetTimer();
                localStorage.setItem("timer", true as any);
                setSearchParams({ verify_otp: true as any })
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }
    const handleOTP = async (e: any) => {
        e.preventDefault();
        const body = {
            email: localStorage.getItem("email"),
            otp: otp.trim()
        }
        const validationErrors = handleValidation();
        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {

                const { result, error } = await validateOTP(body);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                const temp: any = 1
                localStorage.setItem("count1", temp);
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                setTimeout(() => {
                    navigate("/reset-password")
                }, 2500)
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }
    const logos = JSON.parse(localStorage.getItem('logos') as any);
    const logo = logos !== null || logos !== "" ? `data:image/png;base64,${logos?.logo_side_img}` : brandLogo;

    return (
        <div className="login-container">
            <div className='login-main'>
                {/* <div className='login-left'>
                    <div className='login-left_top'>
                        <img src={Group} className='left-image' alt="signup" />
                    </div>
                    <div className='login-left_bottom'></div>
                </div> */}
                {!temp ?
                    <div className='login-right'>
                        <img src={logo} className='logo' alt="logo" />
                        <h3 className='login-header'>Forgot Password</h3>
                        <form className='form'>
                            <div className='form-field2'>
                                <div>
                                    <label className='form-label'>Email</label>
                                    <span className="text-red-600">*</span>
                                </div>
                                <input
                                    className="form-control"
                                    type="email"
                                    placeholder="Enter your Email"
                                    value={username}
                                    onChange={(e) => {
                                        delete errors.username;
                                        setUsername(e.target.value);
                                    }}
                                    required
                                    autoComplete="new-password"
                                />
                                {errors.username && <span className="mt-2 text-danger">{errors.username}</span>}
                            </div>
                            <button className='btn btn-primary mt-4 w-100' onClick={handlePassword}>Confirm</button>
                            <p className='register-text text-center mt-2'>Go Back to <strong style={{ color: "#5627D9" }} onClick={() => navigate("/", { replace: true })} className='str-point'>Sign In</strong></p>
                        </form>
                    </div>
                    :
                    <div className='login-right'>
                        <h3 className='login-header'>Verify OTP</h3>
                        {timer}
                        <form className='form'>
                            <div className='form-field2'>
                                <div>
                                    <label className='form-label'>OTP</label>
                                    <span className="text-red-600">*</span>
                                </div>
                                <div className='password'>

                                    <input
                                        className="form-control"
                                        type={showOTP ? "text" : "password"}
                                        placeholder="Verify your OTP"
                                        value={otp}
                                        onChange={(e) => {
                                            delete errors.otp;
                                            setOtp(e.target.value);
                                        }}
                                        required
                                        autoComplete="new-password"
                                    />
                                    <span className={`password-toggle `} onClick={() => setShowOTP(!showOTP)}>
                                        {!showOTP ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                            <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                        }
                                    </span>
                                </div>
                            </div>
                            {errors.otp && <span className="mt-2 text-danger">{errors.otp}</span>}
                            <button className='btn btn-primary mt-4 w-100' onClick={handleOTP}>Confirm</button>
                            <p className='register-text text-center'>OTP Not Received? <strong onClick={handlePassword} className='str-point'>Resend otp</strong></p>
                            <p className='register-text text-center mt-2'>Go Back to <strong onClick={() => navigate("/", { replace: true })} className='str-point'>Sign In</strong></p>
                        </form>
                    </div>
                }

            </div>
        </div>
    )
}

export default ForgotPassword